import React from 'react';
import { Grid } from '@mui/material';
import HotelSearchHeaderSkeleton from './components/HotelSearchHeader/HotelSearchHeaderSkeleton';

import HotelsResultsContainerSkeleton from './components/HotelsResultsContainer/HotelsResultsContainerSkeleton';

import LoadingImage from '@shared/components/LoadingImage';

const HotelSearchSkeleton = ({
  isMobile = false,
  isLoading,
  viewFullWidhtMap,
}) => {
  // Cantidad de “tarjetas” de hotel a mostrar como placeholder

  return (
    <Grid
      container
      id="GRIDROOTPADRESKELETON"
      direction="column"
      sx={{
        backgroundColor: '#F6F6F6',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        px: { xs: '16px', md: '32px', lg: '116px' },
      }}
    >
      <LoadingImage isOpen={isLoading} site="Hoteleria" />

      {/* Header Skeleton */}
      <Grid container sx={{ px: 3, alignItems: 'center' }}>
        <HotelSearchHeaderSkeleton isMobile={isMobile} />
      </Grid>

      {/* Resultados Skeleton */}
      <HotelsResultsContainerSkeleton
        isMobile={isMobile}
        viewFullWidhtMap={viewFullWidhtMap}
      />
    </Grid>
  );
};

export default HotelSearchSkeleton;
